import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Button from 'components/base/Button';
import Modal from 'components/base/Modal';
import css from './style.scss';
import css2 from '../../AccountNew/style.scss';
import ShapeTooLong from '../../AccountNew/modals/ShapeTooLong';

class Layout extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      showErrorDisplay: true
    }
    this.closeErrorDisplay = this.closeErrorDisplay.bind(this);
  }
  componentDidMount() {
    this.setState({ showErrorDisplay: true })
  }
  closeErrorDisplay = () => {
    this.setState({ showErrorDisplay: false })
    this.props.onOk();
  }
  render() {
    const { message, caption, showNewUI } = this.props;
    return (
      <>
        {showNewUI ? (
          <div className={css2.clsIntegrationCard}>
            <ShapeTooLong
              isOpen={this.state.showErrorDisplay}
              onClose={this.closeErrorDisplay}
              title={caption}
              description={message}
            />
          </div>
        ) : (
          <Modal isOpen={this.state.showErrorDisplay} uniqId="error-modal" caption={caption} width="auto">
            <div className={css.message}>{message}</div>
            <div className={css.buttons}>
              {/* removed width beacause of its affacted in error modal */}
              <Button kind={Button.kind.default} size="large" name="ok" onClick={this.closeErrorDisplay}>Ok</Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}

Layout.propTypes = {
  onOk: PropTypes.func.isRequired,
};

export default Layout;